import { render, staticRenderFns } from "./imgList.vue?vue&type=template&id=1c511486&scoped=true"
import script from "./imgList.vue?vue&type=script&lang=js"
export * from "./imgList.vue?vue&type=script&lang=js"
import style0 from "./imgList.vue?vue&type=style&index=0&id=1c511486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c511486",
  null
  
)

export default component.exports